import { tint } from 'polished';
import { UniversalSurfaceRenderer } from '../../../../platform/UniversalSurfaceRenderer';
import { Matrix } from '../../../../platform/geom/Matrix';
import { Point } from '../../../../platform/geom/Point';
import { Particle } from './Particle';

export class FrameParticle implements Particle {

    private lifetime = .5;
    private age = 0;

    public scale = 1;

    constructor(
        public pos: Point,
        public width: number,
        public height: number,
    ) {
    }

    public update(dt: number): boolean {
        this.age += dt;
        return this.age < this.lifetime;
    }

    public paint(gfx: UniversalSurfaceRenderer, mvm: Matrix): void {

        // Reach a scale of ? over lifetime
        const scale = 1 + .75 * this.age / this.lifetime;
        const sw = this.width * scale;
        const sh = this.height * scale;

        gfx.setTransform(
            Matrix.identity
                .multiply(mvm)
                .translate(this.pos)
                .translate(sw * -.5, sh * -.5)
        );
        gfx.globalAlpha = 1 - this.age / this.lifetime;
        gfx.strokeStyle = tint(this.age / this.lifetime, 'gold');
        gfx.lineWidth = 8 * scale;
        gfx.strokeRect(0, 0, sw, sh);
    }
}
